import {SagaIterator} from 'redux-saga';
import {putResolve, select} from 'redux-saga/effects';

import {getStatesSelector} from 'desktop/selectors/location/location';
import {fetchStates} from 'reducers/location/location';
import {transformBackendRegions} from 'reducers/location/transformBackendRegions/transformBackendRegions';
import {StatesItemType} from 'types/locationType';

/**
 * Gets states for specified country
 * @param {string} country - Country for states requesting
 * @returns {Array<StatesItemType>} States for received country or empty array
 */
export function* getStatesForCountry(
    country: string,
    {
        checkByLength,
        transformRegions,
    }: {
        checkByLength?: boolean;
        transformRegions?: boolean;
    } = {},
): SagaIterator<Array<StatesItemType>> {
    if (!country) return [];
    const alreadyReceivedStates = yield select(getStatesSelector, country);
    if (checkByLength ? alreadyReceivedStates?.length > 0 : alreadyReceivedStates)
        return alreadyReceivedStates;

    try {
        const {
            payload: {data: result},
        } = yield putResolve(fetchStates(country));
        return transformRegions ? transformBackendRegions(result) : result;
    } catch (error) {
        return [];
    }
}
